<template>
  <q-input
    ref="inputRef"
    v-bind="$attrs"
    :model-value="modelValue"
    :error="!promoCode.success"
    :error-message="promoCode.text"
    :rules="[ () => promoCode.success || promoCode.text, ...rules ]"
    lazy-rules="ondemand"
    @blur="focused = false"
    @focus="focused = true"
    @update:modelValue="onInput"
  >
    <template #prepend>
      <q-icon
        name="img:common/icons/percent.svg"
        size="24px"
      />
    </template>
    <template
      v-if="promoCode.text || hint"
      #hint
    >
      <div
        :class="{
          'text-positive': promoCode.text,
        }"
      >
        {{ promoCode.text || hint }}
      </div>
    </template>
  </q-input>
</template>

<script setup>
import { debounce } from 'quasar';
import {
  inject,
  nextTick,
  onMounted,
  ref,
} from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  hint: {
    type: String,
    default: null,
  },
  modelValue: {
    type: String,
    default: '',
  },
  rules: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['loading', 'update:modelValue', 'show-auth-modal']);

const axios = inject('axios', undefined);

let debounceCheckPromoCode;
const inputRef = ref(null);
const focused = ref(false);
const promoCode = ref({
  success: true,
});

async function checkPromoCode() {
  if (!props.modelValue) {
    promoCode.value = {
      success: true,
    };
    inputRef.value.resetValidation();
    emit('loading', false);
    return;
  }
  try {
    const { data } = await axios('/api/promo_codes/search', {
      params: {
        value: props.modelValue,
      },
      skipErrorHandling: focused,
    });

    promoCode.value = {
      text: data,
      success: true,
    };
  } catch (err) {
    const { type, details } = err.response.data.error;

    if (type === 'require_contacts') {
      emit('show-auth-modal', details);
    }

    promoCode.value = {
      text: details,
      success: false,
    };
  } finally {
    if (inputRef.value) {
      inputRef.value.validate();
    }
    emit('loading', false);
  }
}

function onInput(e) {
  emit('update:modelValue', e);
  emit('loading', true);
  debounceCheckPromoCode();
}

onMounted(() => {
  nextTick(() => {
    if (props.modelValue) {
      emit('loading', true);
      checkPromoCode();
    }
  });
  debounceCheckPromoCode = debounce(checkPromoCode, 500);
});

defineExpose({
  checkPromoCode,
});
</script>
